export default __webpack_public_path__ + "static/damixa@1x-09ece9a81573b09dc530a98403c9a065.webp";